var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.editCard.apply(null, arguments)
        },
      },
    },
    [
      _c("PaymentCardForm", {
        staticClass: "mb-2",
        on: { change: _vm.onPaymentCardDataChange },
      }),
      _vm.isErrorShown
        ? _c("FormError", { attrs: { errorMessage: _vm.errorMessage } })
        : _vm._e(),
      _vm._t(
        "default",
        function () {
          return [
            _c("UIButton", {
              attrs: {
                buttonText: "Edit card",
                type: "submit",
                fullWidth: "",
                disabled: !_vm.cardDataValid,
                processing: _vm.processing,
              },
            }),
          ]
        },
        {
          disabled: !_vm.cardDataValid,
          processing: _vm.processing,
          editCard: _vm.editCard,
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }